
import { Vue, Component } from "vue-property-decorator";
import AppBar from "@/components/app/AppBar.vue";
import ErrorAlert from "@/components/alert/ErrorAlert.vue";
import SuccessAlert from "@/components/alert/SuccessAlert.vue";
import Loading from "@/components/app/Loading.vue";
import WarningAlert from "@/components/alert/WarningAlert.vue";
import PrivacyWarning from "@/components/app/PrivacyWarning.vue";

@Component({
  components: {
    PrivacyWarning,
    WarningAlert,
    Loading,
    SuccessAlert,
    ErrorAlert,
    AppBar
  }
})
export default class App extends Vue {
  get showAppBar(): boolean {
    return this.$route.meta?.appBar;
  }

  showPrivacyWarning = false;

  async created() {
    await this.$store.dispatch("loading");
    console.log("Creating App");
    if (await this.$store.getters.isLoggedIn()) {
      await this.$store.dispatch("setUserInfo");
    } else {
      this.showPrivacyWarning = true;
    }

    /*
    await this.$recaptchaLoaded();
    this.$recaptchaInstance.hideBadge();

     */

  }
}
